<template>
  <div class="datatable">
    <div class="dt-list-status">
      <div class="btn-status" :class="scrunch ? 'active' : null" @click="scrunch = !scrunch">
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
        <div class="line scrunch"></div>
      </div>
      <div class="btn-status" :class="!scrunch ? 'active' : null" @click="scrunch = !scrunch">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="dt-header">
      <div class="header-col" style="width: 13%;" @click="setSortOption('name')">name
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'name'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'name' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'name' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 9%;" @click="setSortOption('prefDate')">PREF DATE
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'prefDate'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'prefDate' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'prefDate' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 6%;" @click="setSortOption('projPart')">PROJ PART
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'projPart'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'projPart' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'projPart' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 16%;" @click="setSortOption('fullAddress')">FULL ADDRESS
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'fullAddress'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'fullAddress' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'fullAddress' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 8%;" @click="setSortOption('eventLocation')">LOCATION
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'eventLocation'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'eventLocation' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'eventLocation' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 9%;" @click="setSortOption('start')">start
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'start'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'start' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'start' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 6%;" @click="setSortOption('dur')">dur
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'dur'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'dur' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'dur' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 8%;" @click="setSortOption('end')">end
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'end'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'end' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'end' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 6%;" @click="setSortOption('tz')">tz
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'tz'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'tz' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'tz' && !this.pagingObj.sortReverse"></Icon>
      </div>

      <div class="header-col" style="width: 10%;" @click="setSortOption('onSiteContact')">ON SITE CONTACT
        <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'onSiteContact'"></Icon>
        <Icon name="sort-up" class="sort-icon"
              v-if="this.pagingObj.sortType == 'onSiteContact' && this.pagingObj.sortReverse"></Icon>
        <Icon name="sort-down" class="sort-icon"
              v-if="this.pagingObj.sortType == 'onSiteContact' && !this.pagingObj.sortReverse"></Icon>
      </div>
      <div class="header-col" style="width: 9%;">{{ 'status' }}</div>
    </div>
    <div class="dt-body" :class="scrunch ? 'scrunch' : null">
      <template v-for="(itemNewEvent, index) in events">
        <DataTableRow :editable="editable" :viewMode="viewMode" :eventStatus="eventStatus" :index="index" :item="itemNewEvent"
                              :key="index"></DataTableRow>
      </template>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/sort';
import 'vue-awesome/icons/sort-up';
import 'vue-awesome/icons/sort-down';

import Icon from 'vue-awesome/components/Icon';
import {mapGetters, mapActions} from 'vuex';

import DataTableRow from './DataTableRow';
import DtPaging from './DtPaging';
import consts from '../../_consts';

export default {
  name: 'tableRelatedEvent',
  components: {
    Icon,
    DataTableRow,
    DtPaging
  },
  data () {
    return {
      scrunch: false,
      // START: paging
      pagingObj: {
        currentPage: 1,
        itemsPerPage: '1000',
        totalItems: this.totalItems,
        sortType: 'eventLocation',
        sortReverse: false
      },
      // END: paging
      arrStatus: []
    };
  },
  props: {
    eventStatus: {
      type: String,
      default: ''
    },
    viewMode: {
      type: String,
      default: 'Related'
    },
    editable: {
      type: Boolean,
      default: false
    },
    eventId: {
      type: Number
    }
  },
  computed: {
    events () {
      return this.getEventsRelated;
    },
    totalItems () {
      return this.countEventByStatus(this.eventStatus);
    },
    listEventStatus () {
      return this.getListEvenStatus;
    },
    ...mapGetters({
      getListEvent: 'GETTERS_LIST_EVENT',
      countEventByStatus: 'GETTERS_COUNT_EVENT_BY_STATUS',
      getListEvenStatus: 'GETTERS_LIST_EVENT_STATUS',
      getEventsRelated: 'GETTERS_LIST_EVENT_RELATED'
    })
  },
  methods: {
    changePagingOptions: function (pagingObj) {
      this.pagingObj.currentPage = pagingObj.currentPage;
      this.pagingObj.itemsPerPage = pagingObj.itemsPerPage;
      this.pagingObj.totalItems = pagingObj.totalItems;
    },
    setSortOption: function (sortType) {
      this.pagingObj.sortType = sortType;
      this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
    },
    getListEventParams: function () {
      if (this.eventStatus === '') {
        this.arrStatus = this.getListEvenStatus;
      } else {
        this.arrStatus = [this.eventStatus.toUpperCase()];
      }
      return {
        userId: Number(localStorage.getItem(consts.LOCAL_STORE.userId)),
        status: this.arrStatus,
        options: this.pagingObj,
        clientId: Number(localStorage.getItem(consts.LOCAL_STORE.clientId))
      };
    },
    ...mapActions({
      getEventList: 'ACTION_GET_EVENT_LIST',
      actionGetEventsRelated: 'ACTION_GET_EVENT_RELATED'
    })
  },
  watch: {
    pagingObj: {
      handler: function () {
        this.getEventList(this.getListEventParams());
      },
      deep: true
    },
    listEventStatus: {
      handler: function () {
        let params = {
          eventId: this.eventId,
          status: this.listEventStatus,
          options: this.pagingObj
        }
        this.actionGetEventsRelated(params);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// TableRelatedEvents.vue?698959ff